(function() {
    // ============================================
    // IA SMART SHOP - VERSIÓN DEFINITIVA 2.0
    // Con imágenes, más inteligencia y +1500 líneas
    // ============================================

    // ============================================
    // 1. VARIABLES GLOBALES Y MEMORIA
    // ============================================
    let productosIA = [];
    let memoriaIA = {
        mensajes: [],
        ultimoProducto: null,
        ultimoTema: null,
        nombreUsuario: null,
        ultimosEncontrados: [],
        presupuesto: null,
        contexto: null,
        ultimaCategoria: null,
        ultimaLista: [],
        esperandoConfirmacion: false,
        productoPendiente: null
    };
    const MAX_MEMORIA = 15;
    const IA_BACKEND_URL = 'https://smartshop-admin.smartshop-peru.workers.dev';

    // ============================================
    // 2. CARGA DE PRODUCTOS (CON CACHÉ)
    // ============================================
    async function cargarProductosIA() {
        try {
            const res = await fetch(`${IA_BACKEND_URL}/getProducts?t=` + Date.now(), { 
                cache: 'no-store' 
            });
            const data = await res.json();
            
            if (data.success && data.products && data.products.length > 0) {
                productosIA = data.products;
                try {
                    localStorage.setItem('ia_productos_cache', JSON.stringify({
                        productos: productosIA,
                        timestamp: Date.now()
                    }));
                } catch (e) {}
                console.log('✅ IA: Productos cargados', productosIA.length);
            } else if (productosIA.length === 0) {
                cargarCacheLocal();
            }
        } catch (e) {
            console.error('❌ IA: Error cargando productos', e);
            if (productosIA.length === 0) {
                cargarCacheLocal();
            }
        }
    }

    function cargarCacheLocal() {
        try {
            const cache = localStorage.getItem('ia_productos_cache');
            if (cache) {
                const data = JSON.parse(cache);
                if (Date.now() - data.timestamp < 24 * 60 * 60 * 1000) {
                    productosIA = data.productos;
                    console.log('📦 IA: Productos cargados desde caché', productosIA.length);
                }
            }
        } catch (e) {
            console.warn('⚠️ No se pudo leer caché local', e);
        }
    }

    // ============================================
    // 3. UTILIDADES DE TEXTO
    // ============================================
    function normalizar(txt) {
        if (!txt) return '';
        return txt.toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/[^\w\s]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    function tokenizar(txt) {
        return normalizar(txt).split(' ').filter(w => w.length > 2);
    }

    function capitalizar(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    // ============================================
    // 4. BÚSQUEDA INTELIGENTE DE PRODUCTOS
    // ============================================
    function buscarProducto(msg) {
        if (!productosIA || productosIA.length === 0) return null;
        const msgLower = msg.toLowerCase();
        const tokens = tokenizar(msg);
        if (tokens.length === 0) return null;

        let mejor = null, mejorScore = 0;
        for (const p of productosIA) {
            const nombreNorm = normalizar(p.title || '');
            const descNorm = normalizar(p.descriptionHtml || '');
            let score = 0;
            
            if (msgLower.includes((p.title || '').toLowerCase())) score += 100;
            
            tokens.forEach(t => { 
                if (nombreNorm.includes(t)) score += 30; 
                if (nombreNorm.includes(t.substring(0, t.length - 1))) score += 15;
                if (descNorm.includes(t)) score += 5;
            });

            const sinonimos = {
                'cargador': ['power bank', 'powerbank', 'carga', 'usb', 'solar', 'energia'],
                'audifono': ['auricular', 'headphone', 'earphone', 'bluetooth', 'musica', 'sonido', 'audio'],
                'reloj': ['smartwatch', 'watch', 'pulsera inteligente', 'tiempo', 'hora'],
                'funda': ['case', 'estuche', 'protector', 'carcasa'],
                'joya': ['collar', 'anillo', 'arete', 'pulsera', 'dije', 'oro', 'plata'],
                'regalo': ['obsequio', 'sorpresa', 'detalle', 'presente'],
                'barato': ['economico', 'oferta', 'descuento', 'bajo precio'],
                'deporte': ['gym', 'fitness', 'ejercicio', 'entrenamiento', 'correr']
            };
            
            for (const [clave, alts] of Object.entries(sinonimos)) {
                if (msgLower.includes(clave) || alts.some(a => msgLower.includes(a))) {
                    if (nombreNorm.includes(clave) || alts.some(a => nombreNorm.includes(a))) {
                        score += 60;
                    }
                }
            }
            
            if (score > mejorScore) { mejorScore = score; mejor = p; }
        }
        return mejorScore >= 20 ? mejor : null;
    }

    function buscarProductoPorCategoria(categoria) {
        const catNorm = normalizar(categoria);
        return productosIA.filter(p => {
            const titulo = normalizar(p.title || '');
            const desc = normalizar(p.descriptionHtml || '');
            return titulo.includes(catNorm) || desc.includes(catNorm);
        });
    }

    // ============================================
    // 5. MEMORIA Y CONTEXTO
    // ============================================
    function recordar(rol, texto, meta = {}) {
        memoriaIA.mensajes.push({ rol, texto, meta, timestamp: Date.now() });
        if (memoriaIA.mensajes.length > MAX_MEMORIA) memoriaIA.mensajes.shift();
    }

    function yaSaludo() {
        return memoriaIA.mensajes.some(m => m.meta?.tipo === 'saludo');
    }

    // ============================================
    // 6. OBTENER DATOS FRESCOS DEL WORKER
    // ============================================
    async function obtenerDatosFrescos(producto) {
        try {
            const res = await fetch(`${IA_BACKEND_URL}/getProducts?t=` + Date.now(), { 
                cache: 'no-store' 
            });
            const data = await res.json();
            
            if (data.success && data.products && data.products.length > 0) {
                let productoFresco = data.products.find(p => p.id === producto.id);
                
                if (!productoFresco && producto.handle) {
                    productoFresco = data.products.find(p => p.handle === producto.handle);
                }
                
                if (productoFresco && productoFresco.variants?.nodes?.[0]) {
                    const vFresca = productoFresco.variants.nodes[0];
                    
                    const precioNum = parseFloat(vFresca.price);
                    if (!isNaN(precioNum) && precioNum > 0) {
                        producto.variants.nodes[0].price = precioNum;
                    }
                    
                    const oldPriceNum = parseFloat(vFresca.compareAtPrice);
                    producto.variants.nodes[0].compareAtPrice = 
                        (!isNaN(oldPriceNum) && oldPriceNum > 0) ? oldPriceNum : null;
                    
                    if (vFresca.inventoryQuantity !== null && vFresca.inventoryQuantity !== undefined) {
                        const stockNum = parseInt(vFresca.inventoryQuantity);
                        if (!isNaN(stockNum)) {
                            producto.variants.nodes[0].inventoryQuantity = stockNum;
                        }
                    }
                    
                    return producto.variants.nodes[0];
                }
            }
        } catch (e) {
            console.warn('⚠️ Error consultando Worker:', e);
        }
        return producto.variants.nodes[0];
    }

    // ============================================
    // 7. ANIMACIÓN DEL CARRITO
    // ============================================
    function animarVueloAlCarrito(producto) {
        let cartIcon = document.querySelector('a[href="/cart"]') || 
                       document.querySelector('.header__icon--cart') || 
                       document.querySelector('#cart-icon-bubble') ||
                       document.querySelector('.cart-count-bubble');

        let cartX = window.innerWidth - 50;
        let cartY = 50;

        if (cartIcon) {
            const cartRect = cartIcon.getBoundingClientRect();
            if (cartRect.width > 0 && cartRect.height > 0) {
                cartX = cartRect.left + cartRect.width / 2;
                cartY = cartRect.top + cartRect.height / 2;
            }
        }

        const imagenUrl = producto.featuredImage?.url || null;

        const flying = document.createElement('img');
        flying.src = imagenUrl || 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><rect width="100" height="100" fill="%23d4af37"/><text x="50" y="55" font-size="40" text-anchor="middle" fill="%2308080c">🛍️</text></svg>';
        
        flying.style.cssText = `
            position: fixed !important;
            left: 50% !important;
            top: 50% !important;
            width: 100px !important;
            height: 100px !important;
            border-radius: 50% !important;
            border: 3px solid #d4af37 !important;
            box-shadow: 0 0 30px rgba(212, 175, 55, 1) !important;
            z-index: 2147483647 !important;
            pointer-events: none !important;
            object-fit: cover !important;
            margin-left: -50px !important; 
            margin-top: -50px !important;
            transform: scale(1) !important;
            opacity: 1 !important;
        `;

        document.body.appendChild(flying);

        const startX = window.innerWidth / 2;
        const startY = window.innerHeight / 2;
        const duracion = 1000;
        const startTime = performance.now();

        function step(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duracion, 1);
            const easeProgress = progress * progress; 

            const currentX = startX + (cartX - startX) * easeProgress;
            const currentY = startY + (cartY - startY) * easeProgress;
            const scale = 1 - (0.9 * easeProgress);
            const opacity = 1 - easeProgress;

            flying.style.left = currentX + 'px';
            flying.style.top = currentY + 'px';
            flying.style.transform = `scale(${scale})`;
            flying.style.opacity = opacity;

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                flying.remove();
            }
        }
        requestAnimationFrame(step);
    }

    // ============================================
    // 8. AGREGAR AL CARRITO
    // ============================================
    async function agregarAlCarrito(producto, cantidad = 1) {
        if (!producto || !producto.variants || !producto.variants.nodes || !producto.variants.nodes[0]) {
            return { success: false, message: 'Producto sin variantes' };
        }
        
        const vFresca = await obtenerDatosFrescos(producto);
        const variantIdRaw = vFresca.id || '';
        const variantId = variantIdRaw.includes('/') 
            ? variantIdRaw.split('/').pop() 
            : variantIdRaw;
        
        const stockReal = vFresca.inventoryQuantity || 0;
        
        if (stockReal <= 0) {
            return { success: false, message: `Uy 😢 Lo siento, pero ese producto está agotado.` };
        }
        
        if (cantidad > stockReal) {
            return { success: false, message: `Uy 😢 Solo nos quedan ${stockReal} unidades de ${producto.title}.` };
        }

        animarVueloAlCarrito(producto);

        let restante = parseInt(cantidad);
        let ultimaData = null;
        let totalAgregado = 0;
        let errorShopify = null;

        while (restante > 0) {
            const bloque = Math.min(restante, 20);
            
            try {
                const res = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: parseInt(variantId),
                        quantity: bloque,
                        sections: 'cart-drawer,cart-icon-bubble',
                        sections_url: window.location.pathname
                    })
                });
                
                const data = await res.json();
                
                if (data.status) {
                    errorShopify = data.description || data.message || 'Error desconocido de Shopify';
                    break;
                }
                
                ultimaData = data;
                totalAgregado += bloque;
            } catch (err) {
                errorShopify = err.message;
                break;
            }
            
            restante -= bloque;
        }

        if (totalAgregado === 0) {
            return { 
                success: false, 
                message: `Uy 😢 No pude agregar el producto al carrito. ${errorShopify ? 'Error: ' + errorShopify : ''}` 
            };
        }

        if (ultimaData) {
            try {
                if (ultimaData.sections && ultimaData.sections['cart-icon-bubble']) {
                    const bubble = document.getElementById('cart-icon-bubble');
                    const doc = new DOMParser().parseFromString(ultimaData.sections['cart-icon-bubble'], 'text/html');
                    const nuevo = doc.getElementById('cart-icon-bubble') || doc.body.firstElementChild;
                    if (bubble && nuevo) bubble.innerHTML = nuevo.innerHTML;
                }
            } catch (e) {}
        }

        const cartIcon = document.querySelector('#cart-icon-bubble') ||
                         document.querySelector('.header__icon--cart');
        if (cartIcon) {
            cartIcon.style.transition = 'transform 0.3s ease';
            cartIcon.style.transform = 'scale(1.3)';
            setTimeout(() => { cartIcon.style.transform = 'scale(1)'; }, 300);
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        setTimeout(() => {
            window.location.reload();
        }, 1500);

        if (totalAgregado < cantidad) {
            return { 
                success: true, 
                message: `⚠️ Solo pude agregar ${totalAgregado} de ${cantidad} unidades.`,
                agregado: totalAgregado
            };
        }

        return { success: true, message: 'OK', agregado: totalAgregado };
    }

    // ============================================
    // 9. VACIAR CARRITO
    // ============================================
    function vaciarCarrito() {
        fetch('/cart/clear.js', { 
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })
        .then(() => {
            const bubbles = document.querySelectorAll('.cart-count-bubble');
            bubbles.forEach(bubble => {
                bubble.style.display = 'none';
                const span = bubble.querySelector('span[aria-hidden="true"]');
                if (span) span.textContent = '0';
            });

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                cartDrawer.classList.remove('active');
                cartDrawer.removeAttribute('open');
            }

            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

            setTimeout(() => {
                window.location.reload();
            }, 1000);
        })
        .catch(err => {
            window.location.reload();
        });
    }

    // ============================================
    // 10. GENERAR HTML DE PRODUCTO CON IMAGEN
    // ============================================
    function htmlProducto(producto, vFresca) {
        const img = producto.featuredImage?.url || '';
        const precio = parseFloat(vFresca.price || 0).toFixed(2);
        const precioOld = vFresca.compareAtPrice ? parseFloat(vFresca.compareAtPrice) : null;
        const tieneDesc = precioOld && precioOld > parseFloat(vFresca.price);
        const descPct = tieneDesc ? Math.round(((precioOld - parseFloat(vFresca.price)) / precioOld) * 100) : 0;
        const stock = vFresca.inventoryQuantity || 0;
        
        let html = `<div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; padding: 8px; background: rgba(0,0,0,0.03); border-radius: 8px;">`;
        if (img) {
            html += `<img src="${img}" alt="${producto.title}" style="width: 60px; height: 60px; object-fit: cover; border-radius: 8px; border: 1px solid rgba(212,175,55,0.3);">`;
        } else {
            html += `<div style="width: 60px; height: 60px; display: flex; align-items: center; justify-content: center; background: rgba(212,175,55,0.1); border-radius: 8px; font-size: 24px;">🛍️</div>`;
        }
        html += `<div style="flex: 1;">`;
        html += `<div style="font-weight: 700; color: #1a2b4c; font-size: 0.9rem;">${producto.title}</div>`;
        html += `<div style="font-size: 0.85rem; color: #1b8b3b; font-weight: 600;">S/ ${precio}`;
        if (tieneDesc) {
            html += ` <s style="color: #999; font-weight: 400; font-size: 0.75rem;">S/ ${precioOld.toFixed(2)}</s> <span style="color: #ff0055; font-weight: 700; font-size: 0.75rem;">(-${descPct}%)</span>`;
        }
        html += `</div>`;
        html += `<div style="font-size: 0.7rem; color: ${stock > 0 ? '#1b8b3b' : '#ff0055'};">${stock > 0 ? `✅ ${stock} disponibles` : '❌ Agotado'}</div>`;
        html += `</div></div>`;
        return html;
    }

    // ============================================
    // 11. RESPUESTAS LOCALES (NUEVAS FUNCIONES)
    // ============================================
    async function respuestasLocales(msg, msgNorm, nombre) {

        // --- 11.1 Saludos ---
        if (/\b(hola|buenas|hey|hi|hello|que tal|buenos dias|buenas tardes|buenas noches)\b/.test(msgNorm)) {
            recordar('bot', 'saludo', { tipo: 'saludo' });
            const saludos = yaSaludo()
                ? [`¡Hola de nuevo${nombre}! 👋✨ ¿En qué más te ayudo?`, `¡Hey${nombre}! 😊 ¿Seguimos?`, `¡Holaa otra vez${nombre}! 💖 ¿Qué necesitas?`]
                : [`¡Holaa${nombre}! 👋✨ Soy <strong>SmartShop IA</strong>.<br><br>💖 ¿En qué puedo ayudarte hoy?`, `¡Hey${nombre}! 🌸✨ Bienvenida a <strong>SmartShop</strong>.<br><br>¿Buscas algo especial? 🛍️`, `¡Qué gusto verte${nombre}! 💖 Soy tu asistente.<br><br>¿Te ayudo a encontrar algo lindo? 🔥`];
            return saludos[Math.floor(Math.random() * saludos.length)];
        }

        // --- 11.2 Despedidas ---
        if (/\b(chao|adios|bye|hasta luego|nos vemos|me voy)\b/.test(msgNorm)) {
            const d = [`¡Chaucito${nombre}! 👋💖 Vuelve cuando quieras 🌸`, `¡Hasta pronto${nombre}! 💫 Cuídate mucho 🥰`, `¡Adiós${nombre}! 🌸✨ Fue un placer 💖`];
            return d[Math.floor(Math.random() * d.length)];
        }

        // --- 11.3 Agradecimientos ---
        if (/\b(gracias|muchas gracias|te agradezco|mil gracias)\b/.test(msgNorm)) {
            const r = [`¡De nada${nombre}! 💖 Fue un placer ✨`, `¡Con mucho gusto${nombre}! 💖✨ Vuelve pronto 🛍️`, `¡Para eso estoy${nombre}! 😊💖`];
            return r[Math.floor(Math.random() * r.length)];
        }

        // --- 11.4 Vaciar carrito ---
        if (/\b(vacia|vaciar|vacía|elimina todo|borra todo|limpia el carrito|quita todo)\b/.test(msgNorm)) {
            vaciarCarrito();
            return `🗑️ ¡Listo${nombre}! He vaciado tu carrito por completo. ✨<br><br>¿Qué más deseas buscar hoy? 💖`;
        }

        // --- 11.5 Ofertas (Muestra TODAS con foto) ---
        if (/\b(oferta|ofertas|descuento|descuentos|promo|promocion|promociones|rebaja|barato|economic)\b/.test(msgNorm)) {
            const enOferta = productosIA.filter(p => {
                const v = p.variants?.nodes?.[0];
                return v?.compareAtPrice && parseFloat(v.compareAtPrice) > parseFloat(v.price);
            });
            if (enOferta.length === 0) return `Uy, por ahora no tenemos ofertas activas 😢<br><br>Pero siempre tenemos envío gratis en compras mayores a S/50 🚚💖`;
            
            let resp = `¡Llegaste en el momento perfecto! 🎉🔥<br><br>Tenemos <strong>${enOferta.length} producto(s)</strong> en OFERTA:<br><br>`;
            memoriaIA.ultimosEncontrados = enOferta;
            memoriaIA.ultimaLista = enOferta;
            for (let i = 0; i < enOferta.length; i++) {
                const p = enOferta[i];
                const v = await obtenerDatosFrescos(p);
                resp += `<div style="margin-bottom: 8px;"><strong>${i+1}.</strong> ${htmlProducto(p, v)}</div>`;
            }
            return resp + `¿Te interesa alguno? Responde con el número 💖`;
        }

        // --- 11.6 Envíos ---
        if (/\b(envio|envios|enviar|llega|llegan|llegar|demora|demoran|tarda|tardan|delivery|reparto|courier|agencia|shalom|olva)\b/.test(msgNorm)) {
            memoriaIA.ultimoTema = 'envios';
            return `📦 <strong>Información de envíos:</strong><br><br>🚚 <strong>Lima:</strong> 24-48 horas<br>🚚 <strong>Provincias:</strong> 2-4 días<br>📦 <strong>Agencias:</strong> Shalom, Olva, Marvisur<br><br>✨ <strong>¡Envío GRATIS en compras mayores a S/50!</strong><br><br>📍 Enviamos a todo Perú 💖`;
        }

        // --- 11.7 Pagos ---
        if (/\b(pago|pagos|pagar|yape|plin|transferencia|efectivo|tarjeta|deposito|bcp|interbank|visa|mastercard)\b/.test(msgNorm)) {
            memoriaIA.ultimoTema = 'pagos';
            return `💳 <strong>Formas de pago:</strong><br><br>✅ Yape<br>✅ Plin<br>✅ Transferencia bancaria (BCP, Interbank)<br>✅ Tarjeta de crédito/débito (Visa, Mastercard)<br>✅ Efectivo (contra entrega)<br><br>💖 Coordinamos todo por WhatsApp ✨`;
        }

        // --- 11.8 Ubicación ---
        if (/\b(ubicacion|direccion|donde estan|donde queda|local|tienda fisica|mapa|como llegar)\b/.test(msgNorm)) {
            return `📍 <strong>Nuestra ubicación:</strong><br><br>Psje. Cristal S/N Altura de la Libertad<br>Yurimaguas, Perú 🇵🇪<br><br>🕐 Lun-Sáb: 9am - 8pm<br><br>💻 WhatsApp: +51 916 722 530 💖`;
        }

        // --- 11.9 Horario ---
        if (/\b(horario|horarios|abren|cierran|atienden|abierto|cerrado|domingo|sabado|feriado)\b/.test(msgNorm)) {
            return `🕐 <strong>Nuestro horario:</strong><br><br>📅 Lunes a Sábado: 9am - 8pm<br>📅 Domingos y feriados: cerrado<br><br>💻 Pero mi chat está abierto 24/7 ✨`;
        }

        // --- 11.10 Chistes ---
        if (/\b(chiste|chistes|broma|bromas|gracioso|hazme reir)\b/.test(msgNorm)) {
            const chistes = [
                `😊 ¿Por qué las joyas no van a la playa?<br><br>¡Porque les da miedo que se les corra el brillo! 😂💖`,
                `😂 ¿Qué le dice un collar a otro?<br><br>— ¡Estoy harto de que me lleven de paseo! 😂✨`,
                `😄 ¿Por qué los aretes son tan felices?<br><br>— ¡Porque siempre están colgados de la moda! 💫😊`,
                `🤭 ¿Qué le dijo un anillo a otro?<br><br>— ¡Te falta el dedo! 😂💍`,
                `😆 ¿Qué le dijo un espejo a una joya?<br><br>— ¡Tú sí que brillas con luz propia! ✨💎`
            ];
            return chistes[Math.floor(Math.random() * chistes.length)];
        }

        // --- 11.11 Más barato (con foto) ---
        if (/\b(mas barato|menos cuesta|economico|precio mas bajo|baratito)\b/.test(msgNorm)) {
            const disponibles = productosIA.filter(p => (p.variants?.nodes?.[0]?.inventoryQuantity || 0) > 0);
            if (disponibles.length === 0) return `Uy, ahora mismo no tenemos stock disponible 😢`;
            const ordenados = [...disponibles].sort((a, b) => parseFloat(a.variants.nodes[0].price) - parseFloat(b.variants.nodes[0].price));
            const barato = ordenados[0];
            const vFresca = await obtenerDatosFrescos(barato);
            memoriaIA.ultimoProducto = barato;
            return `¡Buena pregunta! 💰<br><br>El producto más económico es:<br><br>${htmlProducto(barato, vFresca)}<br>¿Te lo agrego al carrito? 🛒💖`;
        }

        // --- 11.12 Más caro (con foto) ---
        if (/\b(mas caro|premium|mas costoso|precio mas alto|lujoso)\b/.test(msgNorm)) {
            const disponibles = productosIA.filter(p => (p.variants?.nodes?.[0]?.inventoryQuantity || 0) > 0);
            if (disponibles.length === 0) return `Uy, ahora mismo no tenemos stock disponible 😢`;
            const ordenados = [...disponibles].sort((a, b) => parseFloat(b.variants.nodes[0].price) - parseFloat(a.variants.nodes[0].price));
            const caro = ordenados[0];
            const vFresca = await obtenerDatosFrescos(caro);
            memoriaIA.ultimoProducto = caro;
            return `¡El más premium! 💎<br><br>${htmlProducto(caro, vFresca)}<br>¿Te interesa? 🛒✨`;
        }

        // --- 11.13 Más vendido (con foto) ---
        if (/\b(mas vendido|mas vendidos|popular|populares|mejor vendido|top ventas|favorito)\b/.test(msgNorm)) {
            const disponibles = productosIA.filter(p => (p.variants?.nodes?.[0]?.inventoryQuantity || 0) > 0);
            if (disponibles.length === 0) return `Uy, ahora mismo no tenemos stock disponible 😢`;
            const top = disponibles[0];
            const vFresca = await obtenerDatosFrescos(top);
            memoriaIA.ultimoProducto = top;
            return `🏆 <strong>El más vendido:</strong><br><br>${htmlProducto(top, vFresca)}<br>¡Es favorito de nuestras clientas! 💖`;
        }

        // --- 11.14 Recomendar (con foto) ---
        if (/\b(recomienda|recomiendas|sugerencia|sugiere|aconseja|regalo|regalar|obsequio|para ella|para mama|para amiga|cumpleaños|aniversario|detalle)\b/.test(msgNorm)) {
            const disponibles = productosIA.filter(p => (p.variants?.nodes?.[0]?.inventoryQuantity || 0) > 0);
            if (disponibles.length === 0) return `Uy, ahora mismo no tenemos stock disponible 😢`;
            const recomendados = disponibles.slice(0, 3);
            memoriaIA.ultimosEncontrados = recomendados;
            memoriaIA.ultimaLista = recomendados;
            let resp = `💖 <strong>${nombre ? nombre + ', ' : ''}te recomiendo:</strong><br><br>`;
            for (let i = 0; i < recomendados.length; i++) {
                const p = recomendados[i];
                const vFresca = await obtenerDatosFrescos(p);
                resp += `<div style="margin-bottom: 8px;"><strong>${i+1}.</strong> ${htmlProducto(p, vFresca)}</div>`;
            }
            resp += `<br>¿Cuál te gusta más? Responde con el número 🛍️💖`;
            return resp;
        }

        // --- 11.15 Comparar (con foto) ---
        if (/\b(comparar|compara|diferencia|mejor entre|vs|o cual)\b/.test(msgNorm)) {
            const tokens = tokenizar(msg);
            const encontrados = [];
            for (const p of productosIA) {
                const nombreNorm = normalizar(p.title || '');
                let score = 0;
                tokens.forEach(t => { if (nombreNorm.includes(t)) score += 10; });
                if (score > 0) encontrados.push({ p, score });
            }
            encontrados.sort((a, b) => b.score - a.score);
            if (encontrados.length < 2) {
                return `Necesito que me digas 2 productos para comparar 🤔<br><br>Ejemplo: <em>"compara aretes bohemios con perla dorada"</em>`;
            }
            const a = encontrados[0].p;
            const b = encontrados[1].p;
            const va = await obtenerDatosFrescos(a);
            const vb = await obtenerDatosFrescos(b);
            return `⚖️ <strong>Comparación:</strong><br><br>
            ${htmlProducto(a, va)}<br>
            ${htmlProducto(b, vb)}<br>
            💡 <strong>Recomendación:</strong> ${parseFloat(va.price) < parseFloat(vb.price) ? `El más económico es <strong>${a.title}</strong>` : `El más económico es <strong>${b.title}</strong>`}<br>
            ¿Te ayudo con algo más? 💖`;
        }

        // --- 11.16 Stock ---
        if (/\b(stock|queda|unidades|disponible)\b/.test(msgNorm)) {
            const encontrado = buscarProducto(msg) || memoriaIA.ultimoProducto;
            if (encontrado) {
                const vFresca = await obtenerDatosFrescos(encontrado);
                const s = vFresca.inventoryQuantity || 0;
                memoriaIA.ultimoProducto = encontrado;
                return `📦 <strong>${encontrado.title}</strong><br><br>${s === 0 ? '❌ AGOTADO por ahora 😢' : (s <= 3 ? `⚠️ ¡Solo quedan <strong>${s}</strong> unidades!` : `✅ Tenemos <strong>${s}</strong> disponibles`)}<br><br>¿Lo agregamos al carrito? 🛒`;
            }
            const totalStock = productosIA.reduce((s, p) => s + (p.variants?.nodes?.[0]?.inventoryQuantity || 0), 0);
            const conStock = productosIA.filter(p => (p.variants?.nodes?.[0]?.inventoryQuantity || 0) > 0).length;
            return `📊 En total tenemos <strong>${totalStock}</strong> unidades en stock, repartidas en <strong>${conStock}</strong> productos.<br><br>¿Qué producto te interesa? 🔍`;
        }

        // --- 11.17 Precio (con foto) ---
        if (/\b(precio|precios|cuanto|cuesta|vale|valor)\b/.test(msgNorm)) {
            const encontrado = buscarProducto(msg) || memoriaIA.ultimoProducto;
            if (encontrado) {
                const vFresca = await obtenerDatosFrescos(encontrado);
                memoriaIA.ultimoProducto = encontrado;
                return `💰 <strong>Precio de ${encontrado.title}:</strong><br><br>${htmlProducto(encontrado, vFresca)}<br>¿Te interesa? 🛒`;
            }
            if (productosIA.length === 0) return `Uy, aún no tenemos productos cargados 😅`;
            const min = Math.min(...productosIA.map(p => parseFloat(p.variants.nodes[0].price)));
            const max = Math.max(...productosIA.map(p => parseFloat(p.variants.nodes[0].price)));
            return `💰 <strong>Nuestros precios:</strong><br><br>📉 Desde <strong>S/ ${min.toFixed(2)}</strong><br>📈 Hasta <strong>S/ ${max.toFixed(2)}</strong><br><br>¿Buscas algo en especial? 🔍`;
        }

        // --- 11.18 Lista de productos (TODOS con foto) ---
        if (/\b(producto|productos|catalogo|lista|tienen|venden|ofrecen|que hay)\b/.test(msgNorm)) {
            if (productosIA.length === 0) return `Uy, aún no tenemos productos cargados 😅`;
            memoriaIA.ultimosEncontrados = productosIA;
            memoriaIA.ultimaLista = productosIA;
            let resp = `🛍️ <strong>Nuestro catálogo (${productosIA.length} productos):</strong><br><br>`;
            for (let i = 0; i < productosIA.length; i++) {
                const p = productosIA[i];
                const vFresca = await obtenerDatosFrescos(p);
                resp += `<div style="margin-bottom: 8px;"><strong>${i+1}.</strong> ${htmlProducto(p, vFresca)}</div>`;
            }
            return resp + '<br><br>¿Qué producto te interesa? Responde con el número o nombre 💖';
        }

        // --- 11.19 Agotados (TODOS con foto) ---
        if (/\b(agotado|agotados|acabo|no hay|sin stock|se acabo)\b/.test(msgNorm)) {
            const agotados = productosIA.filter(p => (p.variants?.nodes?.[0]?.inventoryQuantity || 0) === 0);
            if (agotados.length === 0) return `¡Buenas noticias! 🎉 Todo tiene stock disponible ✨`;
            let resp = `Uy, estos se agotaron por ahora 😢<br><br>`;
            for (const p of agotados) {
                const vFresca = await obtenerDatosFrescos(p);
                resp += `${htmlProducto(p, vFresca)}`;
            }
            resp += `<br>¿Quieres que te recomiende algo similar? 💡`;
            return resp;
        }

        // --- 11.20 Ayuda ---
        if (/\b(ayuda|ayudame|puedes hacer|que sabes|que puedes|opciones)\b/.test(msgNorm)) {
            return `💖 <strong>Puedo ayudarte con:</strong><br><br>🛍️ Productos y catálogo<br>💰 Precios y ofertas<br>📦 Envíos y pagos<br>📍 Ubicación y horarios<br>🎁 Recomendaciones<br>⚖️ Comparar productos<br>🛒 Agregar al carrito<br>📸 Ver fotos de productos<br>🔢 Elegir por número<br>💬 Y mucho más ✨<br><br>¿Qué te gustaría saber? 💖`;
        }

        // --- 11.21 Agregar al carrito ---
        if (/\b(agrega|agregalo|agregala|agrego|añade|anadelo|anadela|pon|ponlo|ponla|mete|metelo|metela|quiero comprar|lo quiero|la quiero|sumalo|sumala)\b/.test(msgNorm)) {
            
            let cantidad = 1;
            const matchCantidad = msgNorm.match(/\b(\d+)\b/);
            if (matchCantidad) {
                cantidad = parseInt(matchCantidad[1]);
            }

            let encontrado = buscarProducto(msg);
            
            if (!encontrado) {
                const palabrasClave = msgNorm.split(' ').filter(w => w.length > 3);
                for (const palabra of palabrasClave) {
                    const p = productosIA.find(prod => normalizar(prod.title).includes(palabra));
                    if (p) { encontrado = p; break; }
                }
            }

            if (!encontrado && memoriaIA.ultimoProducto) {
                encontrado = memoriaIA.ultimoProducto;
            }

            if (!encontrado && memoriaIA.ultimosEncontrados && memoriaIA.ultimosEncontrados.length > 0) {
                encontrado = memoriaIA.ultimosEncontrados[0];
            }

            if (encontrado) {
                const vFresca = await obtenerDatosFrescos(encontrado);
                const stockDisponible = vFresca.inventoryQuantity || 0;

                if (stockDisponible <= 0) {
                    return `Uy 😢 <strong>${encontrado.title}</strong> está agotado por ahora.<br><br>¿Quieres que te recomiende algo similar? 💡`;
                }
                if (cantidad > stockDisponible) {
                    return `Uy 😢 <strong>Lo siento${nombre}</strong>, pero solo nos quedan <strong>${stockDisponible} unidad(es)</strong> de <strong>${encontrado.title}</strong> en stock.<br><br>No puedo agregar ${cantidad} al carrito. ¿Quieres que agregue las ${stockDisponible} disponibles? 🛒💖`;
                }

                const resultado = await agregarAlCarrito(encontrado, cantidad);
                
                if (!resultado.success) {
                    return `${resultado.message}<br><br>¿Quieres intentarlo de nuevo? 💖`;
                }
                
                memoriaIA.ultimoProducto = encontrado;
                return `✅ ¡Listo${nombre}! Agregué <strong>${resultado.agregado || cantidad} unidad(es)</strong> de <strong>${encontrado.title}</strong> al carrito 🛒<br><br>💰 Precio c/u: S/ ${parseFloat(vFresca.price).toFixed(2)}<br><br>¡Gracias por tu compra! 💖 ¿Deseas algo más? ✨`;
            }
            return `Dime cuál producto quieres agregar 🤔<br><br>Ejemplo: <em>"agrega 5 audífonos"</em> 🛒`;
        }

        // --- 11.22 Confirmación "SÍ" ---
        if (/\b(si|sii|siii|sip|claro|dale|ok|okay|okey|vale|porfa|porfavor|por favor|yes|yep|obvio|obviamente|quiero|si quiero|si porfa|si dale|va|esta bien|bueno|perfecto|de acuerdo|afirmativo|correcto|exacto|eso|eso mismo)\b/.test(msgNorm)) {
            const p = memoriaIA.ultimoProducto || (memoriaIA.ultimosEncontrados && memoriaIA.ultimosEncontrados[0]);
            
            if (p) {
                const vFresca = await obtenerDatosFrescos(p);
                const stockDisponible = vFresca.inventoryQuantity || 0;

                if (stockDisponible <= 0) {
                    return `Uy 😢 <strong>${p.title}</strong> está agotado por ahora.<br><br>¿Quieres que te recomiende algo similar? 💡`;
                }
                
                const resultado = await agregarAlCarrito(p, 1);
                if (!resultado.success) {
                    return `${resultado.message}<br><br>¿Quieres intentarlo de nuevo? 💖`;
                }
                
                memoriaIA.ultimoProducto = null;
                return `✅ ¡Listo${nombre}! Agregué <strong>${p.title}</strong> al carrito 🛒<br><br>💰 Precio: S/ ${parseFloat(vFresca.price).toFixed(2)}<br><br>¡Gracias por tu compra! 💖 ¿Deseas algo más? ✨`;
            }
            return `¿Qué producto quieres que agregue? 🤔<br><br>Dime el nombre y lo agrego 🛒💖`;
        }

        // --- 11.23 Preguntas frecuentes ---
        if (/\b(garantia|devolucion|cambio|reembolso|reclamo)\b/.test(msgNorm)) {
            return `🛡️ <strong>Garantía y devoluciones:</strong><br><br>✅ Aceptamos cambios dentro de los 7 días<br>✅ Producto debe estar en perfecto estado<br>✅ Coordinamos por WhatsApp<br><br>💖 Tu satisfacción es nuestra prioridad ✨`;
        }

        if (/\b(mayorista|por mayor|al por mayor|distribuidor|revendedor)\b/.test(msgNorm)) {
            return `📦 <strong>Ventas al por mayor:</strong><br><br>✅ Tenemos precios especiales para mayoristas<br>✅ Mínimo 10 unidades<br>✅ Escríbenos por WhatsApp para coordinar<br><br>💻 +51 916 722 530 💖`;
        }

        if (/\b(ruc|factura|boleta|comprobante)\b/.test(msgNorm)) {
            return `🧾 <strong>Comprobantes:</strong><br><br>✅ Emitimos boleta y factura<br>✅ Solo necesitas tu RUC o DNI<br>✅ Te lo enviamos por WhatsApp o email<br><br>💖 Coordinamos al momento de la compra ✨`;
        }

        if (/\b(seguimiento|rastrear|tracking|mi pedido|estado del pedido)\b/.test(msgNorm)) {
            return `📦 <strong>Seguimiento de pedidos:</strong><br><br>✅ Te enviamos el número de tracking por WhatsApp<br>✅ Puedes rastrearlo en la web de la agencia<br>✅ Si tienes dudas, escríbenos<br><br>💻 +51 916 722 530 💖`;
        }

        // --- 11.24 Selección por número (con foto) ---
        const matchNumero = msgNorm.match(/^(?:el|la|opcion|numero|nro|n|agrega el|agrega la|quiero el|quiero la)\s*(\d+)$/) || msgNorm.match(/^(\d+)$/);
        if (matchNumero) {
            const indice = parseInt(matchNumero[1]) - 1;
            const lista = memoriaIA.ultimosEncontrados || [];
            if (lista[indice]) {
                const p = lista[indice];
                const vFresca = await obtenerDatosFrescos(p);
                const stockDisponible = vFresca.inventoryQuantity || 0;

                if (stockDisponible <= 0) {
                    return `Uy 😢 <strong>${p.title}</strong> está agotado por ahora.<br><br>¿Quieres que te recomiende algo similar? 💡`;
                }
                
                const resultado = await agregarAlCarrito(p, 1);
                if (!resultado.success) {
                    return `${resultado.message}<br><br>¿Quieres intentarlo de nuevo? 💖`;
                }
                
                memoriaIA.ultimoProducto = p;
                return `✅ ¡Listo${nombre}! Agregué <strong>${p.title}</strong> al carrito 🛒<br><br>💰 Precio: S/ ${parseFloat(vFresca.price).toFixed(2)}<br><br>¡Gracias por tu compra! 💖 ¿Deseas algo más? ✨`;
            }
            return `No encontré ese número en la lista 🤔<br><br>¿Puedes decirme el nombre del producto? 🛍️💖`;
        }

        // --- 11.25 Mostrar foto de producto ---
        if (/\b(foto|imagen|muestra|ver|muestrame|enseña|enseñame)\b/.test(msgNorm)) {
            const encontrado = buscarProducto(msg) || memoriaIA.ultimoProducto;
            if (encontrado) {
                const vFresca = await obtenerDatosFrescos(encontrado);
                memoriaIA.ultimoProducto = encontrado;
                return `📸 <strong>Aquí tienes la foto de ${encontrado.title}:</strong><br><br>${htmlProducto(encontrado, vFresca)}<br>¿Te gusta? 🛒💖`;
            }
            return `Dime qué producto quieres ver en foto 🤔<br><br>Ejemplo: <em>"foto de audífonos"</em> 📸`;
        }

        // --- 11.26 Categorías disponibles ---
        if (/\b(categorias|categoria|que tipos|que clases|tipos de productos)\b/.test(msgNorm)) {
            const cats = new Set();
            productosIA.forEach(p => {
                const palabras = normalizar(p.title).split(' ');
                if (palabras.length > 0) cats.add(palabras[0]);
            });
            const listaCats = [...cats].slice(0, 15);
            return `📂 <strong>Categorías disponibles:</strong><br><br>${listaCats.map(c => `• ${capitalizar(c)}`).join('<br>')}<br><br>¿Qué categoría te interesa? 🔍`;
        }

        // --- 11.27 Productos por categoría (con foto) ---
        const matchCategoria = msgNorm.match(/(?:productos de|tienen de|venden de|busco de|quiero de|muestrame de|ver de)\s+(\w+)/);
        if (matchCategoria) {
            const categoria = matchCategoria[1];
            const encontrados = buscarProductoPorCategoria(categoria);
            if (encontrados.length > 0) {
                memoriaIA.ultimosEncontrados = encontrados;
                memoriaIA.ultimaCategoria = categoria;
                let resp = `🔍 <strong>Productos de "${categoria}" (${encontrados.length}):</strong><br><br>`;
                for (let i = 0; i < encontrados.length; i++) {
                    const p = encontrados[i];
                    const vFresca = await obtenerDatosFrescos(p);
                    resp += `<div style="margin-bottom: 8px;"><strong>${i+1}.</strong> ${htmlProducto(p, vFresca)}</div>`;
                }
                return resp + `<br>¿Cuál te interesa? Responde con el número 🛍️💖`;
            }
            return `Uy, no encontré productos de "${categoria}" en este momento 😢<br><br>¿Quieres ver todo el catálogo? Escribe "productos" 💖`;
        }

        // --- 11.28 Novedades ---
        if (/\b(novedades|nuevo|nuevos|recien llegado|ultimos|recientes)\b/.test(msgNorm)) {
            const disponibles = productosIA.filter(p => (p.variants?.nodes?.[0]?.inventoryQuantity || 0) > 0);
            const recientes = disponibles.slice(-5).reverse();
            if (recientes.length === 0) return `Uy, no hay novedades por ahora 😢`;
            memoriaIA.ultimosEncontrados = recientes;
            let resp = `✨ <strong>Novedades (últimos 5):</strong><br><br>`;
            for (let i = 0; i < recientes.length; i++) {
                const p = recientes[i];
                const vFresca = await obtenerDatosFrescos(p);
                resp += `<div style="margin-bottom: 8px;"><strong>${i+1}.</strong> ${htmlProducto(p, vFresca)}</div>`;
            }
            return resp + `<br>¿Te interesa alguno? 🛍️💖`;
        }

        // --- 11.29 Cómo comprar ---
        if (/\b(como comprar|como compro|pasos para comprar|guia de compra|proceso de compra)\b/.test(msgNorm)) {
            return `🛒 <strong>¿Cómo comprar?</strong><br><br>1️⃣ Elige tu producto favorito<br>2️⃣ Agrégalo al carrito<br>3️⃣ Ve al carrito y revisa tu pedido<br>4️⃣ Elige tu método de pago<br>5️⃣ Confirma y listo ✨<br><br>💖 Si tienes dudas, escríbenos por WhatsApp: +51 916 722 530`;
        }

        // --- 11.30 Cupones ---
        if (/\b(cupon|cupones|descuento especial|codigo de descuento|promo especial)\b/.test(msgNorm)) {
            return `🎟️ <strong>Cupones activos:</strong><br><br>✅ <strong>BIENVENIDA10</strong> - 10% en tu primera compra<br>✅ <strong>ENVIOGRATIS</strong> - Envío gratis en compras > S/50<br>✅ <strong>SMART20</strong> - 20% en joyas seleccionadas<br><br>💖 Aplica el cupón al finalizar la compra ✨`;
        }

        // --- 11.31 Productos baratos (lista con foto) ---
        if (/\b(productos baratos|lista de baratos|economicos|de bajo precio|accesibles)\b/.test(msgNorm)) {
            const disponibles = productosIA.filter(p => (p.variants?.nodes?.[0]?.inventoryQuantity || 0) > 0);
            const baratos = [...disponibles].sort((a, b) => parseFloat(a.variants.nodes[0].price) - parseFloat(b.variants.nodes[0].price)).slice(0, 5);
            if (baratos.length === 0) return `Uy, no hay productos disponibles 😢`;
            memoriaIA.ultimosEncontrados = baratos;
            let resp = `💰 <strong>Los 5 más económicos:</strong><br><br>`;
            for (let i = 0; i < baratos.length; i++) {
                const p = baratos[i];
                const vFresca = await obtenerDatosFrescos(p);
                resp += `<div style="margin-bottom: 8px;"><strong>${i+1}.</strong> ${htmlProducto(p, vFresca)}</div>`;
            }
            return resp + `<br>¿Cuál te interesa? 🛒💖`;
        }

        // --- 11.32 Productos premium (lista con foto) ---
        if (/\b(productos premium|lista de premium|caros|lujosos|de lujo|alta gama)\b/.test(msgNorm)) {
            const disponibles = productosIA.filter(p => (p.variants?.nodes?.[0]?.inventoryQuantity || 0) > 0);
            const caros = [...disponibles].sort((a, b) => parseFloat(b.variants.nodes[0].price) - parseFloat(a.variants.nodes[0].price)).slice(0, 5);
            if (caros.length === 0) return `Uy, no hay productos disponibles 😢`;
            memoriaIA.ultimosEncontrados = caros;
            let resp = `💎 <strong>Los 5 más premium:</strong><br><br>`;
            for (let i = 0; i < caros.length; i++) {
                const p = caros[i];
                const vFresca = await obtenerDatosFrescos(p);
                resp += `<div style="margin-bottom: 8px;"><strong>${i+1}.</strong> ${htmlProducto(p, vFresca)}</div>`;
            }
            return resp + `<br>¿Cuál te interesa? 🛒💖`;
        }

        // --- 11.33 Producto específico (con foto) ---
        const producto = buscarProducto(msg);
        if (producto) {
            memoriaIA.ultimoProducto = producto;
            const vFresca = await obtenerDatosFrescos(producto);
            return `¡Mira qué lindo${nombre}! 💖<br><br>${htmlProducto(producto, vFresca)}<br>¿Lo agregamos al carrito? 🛒💖`;
        }

        return null;
    }

    // ============================================
    // 12. FALLBACK IA (CLOUDFLARE)
    // ============================================
    async function fallbackIA(mensaje) {
        const historial = memoriaIA.mensajes.slice(-6).map(m => ({
            role: m.rol === 'usuario' ? 'user' : 'assistant',
            content: m.texto
        }));

        try {
            const res = await fetch(`${IA_BACKEND_URL}/ia`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ mensaje, historial })
            });
            const data = await res.json();
            if (data.success) return data.respuesta;
            return '🤔 Uy, no pude procesar tu mensaje. Intenta de nuevo.';
        } catch (e) {
            console.error('❌ Error fallback IA:', e);
            return '🤔 Uy, tuve un problema. ¿Puedes repetirlo?';
        }
    }

    // ============================================
    // 13. FUNCIÓN PRINCIPAL getAIResponse
    // ============================================
    async function getAIResponse(mensaje) {
        const msg = mensaje.trim();
        if (!msg) return null;

        recordar('usuario', msg);
        memoriaIA.nombreUsuario = window.currentUser?.name?.split(' ')[0] || null;
        const msgNorm = normalizar(msg);
        const nombre = memoriaIA.nombreUsuario ? ` ${memoriaIA.nombreUsuario}` : '';

        const respuestaLocal = await respuestasLocales(msg, msgNorm, nombre);
        if (respuestaLocal) {
            recordar('bot', respuestaLocal);
            return respuestaLocal;
        }

        const respuestaIA = await fallbackIA(msg);

        let productoMencionado = null;
        for (const p of productosIA) {
            if (normalizar(respuestaIA).includes(normalizar(p.title))) {
                productoMencionado = p;
                break;
            }
        }
        
        if (productoMencionado) {
            memoriaIA.ultimoProducto = productoMencionado;
            console.log('🧠 IA: Producto recordado del Worker:', productoMencionado.title);
        }

        const matchAgregar = respuestaIA.match(/\[AGREGAR_AL_CARRITO:(.+?)\]/);
        if (matchAgregar) {
            const nombreProducto = matchAgregar[1].trim();
            const productoEncontrado = productosIA.find(p =>
                normalizar(p.title).includes(normalizar(nombreProducto))
            );

            if (productoEncontrado) {
                const resultado = await agregarAlCarrito(productoEncontrado);
                if (!resultado.success) {
                    const respuestaFinal = `Uy 😢 ${resultado.message}<br><br>¿Quieres intentarlo de nuevo? 💖`;
                    recordar('bot', respuestaFinal);
                    return respuestaFinal;
                }
                const vFresca = await obtenerDatosFrescos(productoEncontrado);
                const respuestaFinal = `✅ ¡Listo${nombre}! Agregué <strong>${productoEncontrado.title}</strong> al carrito 🛒<br><br>💰 Precio: S/ ${parseFloat(vFresca.price).toFixed(2)}<br><br>¡Gracias por tu compra! 💖 ¿Deseas algo más? ✨`;
                recordar('bot', respuestaFinal);
                return respuestaFinal;
            }
        }

        recordar('bot', respuestaIA);
        return respuestaIA;
    }

    window.getAIResponse = getAIResponse;

    // ============================================
    // 14. BOTÓN IA FIJO EN PANTALLA (SIN TOCAR)
    // ============================================
    const ALTURA_BOTON = 0.70;

    function fijarChatEnPantalla() {
        const btn = document.querySelector('.chat-float-ai');
        const modal = document.querySelector('.chat-modal-ai');

        [btn, modal].forEach(el => {
            if (el && el.parentElement !== document.body) document.body.appendChild(el);
        });

        if (window.innerWidth <= 749) {
            if (btn && !btn.dataset.dragInit) {
                btn.dataset.dragInit = 'true';
                const savedX = localStorage.getItem('chat_btn_x');
                const savedY = localStorage.getItem('chat_btn_y');
                if (savedX !== null && savedY !== null) {
                    btn.style.setProperty('position', 'fixed', 'important');
                    btn.style.setProperty('left', savedX + 'px', 'important');
                    btn.style.setProperty('top', savedY + 'px', 'important');
                    btn.style.setProperty('bottom', 'auto', 'important');
                } else {
                    btn.style.setProperty('position', 'fixed', 'important');
                    btn.style.setProperty('left', '16px', 'important');
                    btn.style.setProperty('top', 'auto', 'important');
                    btn.style.setProperty('bottom', '80px', 'important');
                }

                let dragging = false, startX, startY, initX, initY;

                const onStart = (e) => {
                    const p = e.touches ? e.touches[0] : e;
                    startX = p.clientX; startY = p.clientY;
                    const r = btn.getBoundingClientRect();
                    initX = r.left; initY = r.top;
                    dragging = true;
                };
                const onMove = (e) => {
                    if (!dragging) return;
                    e.preventDefault();
                    const p = e.touches ? e.touches[0] : e;
                    let nx = initX + (p.clientX - startX);
                    let ny = initY + (p.clientY - startY);
                    nx = Math.max(8, Math.min(nx, window.innerWidth - btn.offsetWidth - 8));
                    ny = Math.max(8, Math.min(ny, window.innerHeight - btn.offsetHeight - 8));
                    btn.style.setProperty('left', nx + 'px', 'important');
                    btn.style.setProperty('top', ny + 'px', 'important');
                    btn.style.setProperty('bottom', 'auto', 'important');
                };
                const onEnd = () => {
                    if (!dragging) return;
                    dragging = false;
                    localStorage.setItem('chat_btn_x', parseInt(btn.style.left));
                    localStorage.setItem('chat_btn_y', parseInt(btn.style.top));
                };

                btn.addEventListener('mousedown', onStart);
                btn.addEventListener('touchstart', onStart, { passive: false });
                document.addEventListener('mousemove', onMove);
                document.addEventListener('touchmove', onMove, { passive: false });
                document.addEventListener('mouseup', onEnd);
                document.addEventListener('touchend', onEnd);
            }
            return;
        }

        function anclar(el, topDeseado) {
            if (!el) return;
            el.style.setProperty('position', 'fixed', 'important');
            el.style.setProperty('bottom', 'auto', 'important');
            el.style.setProperty('top', '0px', 'important');
            const offset = el.getBoundingClientRect().top;
            el.style.setProperty('top', (topDeseado - offset) + 'px', 'important');
        }

        anclar(btn, window.innerHeight * ALTURA_BOTON);
        if (modal && getComputedStyle(modal).display !== 'none') {
            anclar(modal, 80);
        }
    }

    let _ticking = false;
    function pedirFijar() {
        if (_ticking) return;
        _ticking = true;
        requestAnimationFrame(() => { fijarChatEnPantalla(); _ticking = false; });
    }

    document.addEventListener('DOMContentLoaded', function() {
        cargarCacheLocal();
        cargarProductosIA();
        setInterval(cargarProductosIA, 30000);

        fijarChatEnPantalla();
        window.addEventListener('scroll', pedirFijar, { passive: true });
        window.addEventListener('resize', pedirFijar);
        window.addEventListener('load', pedirFijar);

        document.addEventListener('click', function(e) {
            if (e.target.closest('.chat-float-ai, .chat-close')) {
                setTimeout(pedirFijar, 50);
            }
        });
    });

})();